export default __webpack_public_path__ + "static/media/illustration-algohealth-w@2x.f1251956.webp";